import { createContext, useContext } from "react";
import type { ApplicationFilters } from "../../hooks/useApplicationQueryParams";
import type { ColumnFilterContextValue } from "../../utils/columnFilters";

type ColumnFiltersContextValue = ColumnFilterContextValue & {
  setFilters: (
    updater: (prev: ApplicationFilters | undefined) => ApplicationFilters
  ) => void;
};

// Lets AG Grid header components (rendered through React portals) reach the table's filter
// state without rebuilding every column definition when a filter changes.
export const ColumnFiltersContext =
  createContext<ColumnFiltersContextValue | null>(null);

export const useColumnFiltersContext = () => useContext(ColumnFiltersContext);
